const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Tím obchodu s pneumatikami",
    car: "Tím autodilerov",
    lkw: "Tím nákladných vozidiel",
    em_otr: "Tím EM/OTR",
    farm_tractor: "Tím poľnohospodárskych traktorov",
    bandag: "Tím Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
